import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { DefaultLinkSimple, Link } from '@design-system/link';
import { MediaContent } from './MediaContent';
import { EMBED_TYPES } from '../constants';
import { normalizeType } from '../utils';
export const Thumbnail = ({ aspectRatio, embed, href, isInternalLink, renderEmptyPreview, withLink = true, }) => {
    const { thumbnail_url: thumbnailUrl, url } = embed;
    const type = normalizeType(embed.type);
    const imgUrl = type === EMBED_TYPES.PHOTO ? url : thumbnailUrl;
    if (!imgUrl && !renderEmptyPreview) {
        return null;
    }
    const content = (_jsx(MediaContent, { aspectRatio: aspectRatio, embed: embed, imgUrl: imgUrl, renderEmptyPreview: renderEmptyPreview }));
    if (!withLink || !href) {
        return content;
    }
    if (isInternalLink) {
        return (_jsx(StyledLink, { "aria-hidden": "true", tabIndex: -1, to: href, children: content }));
    }
    return (_jsx(DefaultLinkSimple, { "aria-hidden": "true", href: href, tabIndex: -1, target: "_blank", children: content }));
};
const StyledLink = styled(Link) `
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;
//# sourceMappingURL=Thumbnail.js.map